import { useEffect } from 'react';
import { FormPacketSelectorTypes } from '@frontend/form-packet-selector';
import { useSendFormsStore } from '../store';

interface UsePersonConfigProps {
  person: FormPacketSelectorTypes.MinimalPersonData | null;
}

const usePersonConfig = ({ person }: UsePersonConfigProps) => {
  const { setPersonId, setPersonName } = useSendFormsStore(['setPersonId', 'setPersonName']);
  const personId = person?.id ?? '';
  const firstName = person?.firstName ?? '';
  const lastName = person?.lastName ?? '';

  useEffect(() => {
    setPersonId(personId);
    setPersonName({
      firstName,
      lastName,
    });
  }, [personId, firstName, lastName, setPersonId, setPersonName]);
};

export default usePersonConfig;
